import axios from 'axios'
import SortService from '@/services/sort.service'

export default {
  namespaced: true,
  state: {
    loadingLead: false,
    lead: {},
    beneficiaries: [],
    scripts: []
  },
  mutations: {
    SET_LOADING_LEAD(state, loading) {
      state.loadingLead = loading;
    },
    SET_LEAD(state, lead) {
      state.lead = lead;
    },
    SET_BENEFICIARIES(state, beneficiaries) {
      state.beneficiaries = beneficiaries;
    },
    SET_SCRIPTS(state, scripts) {
      state.scripts = scripts;
    },
    ADD_SCRIPT(state, script) {
      state.scripts.push(script);
    },
    DELETE_SCRIPT(state, script_id) {
      const index = state.scripts.findIndex(script => script.id === script_id);
      state.scripts.splice(index, 1);
    },
    "SOCKET_UPDATE_LEAD"(state, data) {
      state.lead = data.type_id === 2 ? SortService.sortLead(data) : SortService.sortHealthLead(data);
    },
    "SOCKET_UPDATE_PREMIUM_CARRIER"(state, data){
      state.lead.premium_carrier = SortService.capitalizeText(Object.keys(data.premium_carrier)[0].split('_')).join(' ');
      state.lead.premium_price = "$" + data.premium_carrier[Object.keys(data.premium_carrier)[0]];
    }
  },
  getters: {
    lead: state => state.lead,
    loadingLead: state => state.loadingLead,
    beneficiaries: state => state.beneficiaries,
    beneficiary: state => {
      if (state.beneficiaries) return {};
      return state.beneficiaries[0];
    },
    scripts: state => state.scripts
  },
  actions: {
    loadLead({ commit, dispatch, rootState }, lead_id) {
      commit("SET_LOADING_LEAD", true);

      axios.get(`lead/${lead_id}`)
        .then(res => {
          const lead = res.data.lead.type_id === 2 ? SortService.sortLead(res.data.lead) : SortService.sortHealthLead(res.data.lead);

          commit("SET_LEAD", lead);

          if ('plates' in lead) {
             commit(
               "plates/setPlates",
               lead.plates,
               { root: true }
             );
           } else {
             lead.plates = rootState.plates;
          }

          if (rootState.auth.user.role_id == 1) {
            dispatch("agents/loadAgentWithSuitableState", res.data.lead.state_id, { root: true });
          }

          axios.get(`beneficiaries/${lead_id}`)
            .then(res => {
              commit("SET_BENEFICIARIES", res.data.beneficiaries);
            })
            .catch(e => console.log(e));

          axios.get(`/agents/scripts/${rootState.auth.user.id}/2`)
            .then(res => commit("SET_SCRIPTS", res.data.scripts))
            .catch(e => console.log(e));

          dispatch("notes/loadNotes", lead_id, { root: true });
          dispatch("records/loadRecordsByLeadId", lead_id, { root: true });

          commit("SET_LOADING_LEAD", false);
        })
        .catch(e => {
          console.log(e);
          commit("SET_LOADING_LEAD", false);
        })
    },

  },
}

